import React, { useState, useEffect } from "react";
import {
  Box, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton, Button,
  FormControl, Select, MenuItem, Modal, Typography, Divider, Tooltip
} from "@mui/material";
import ReactPaginate from "react-paginate";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../../Component/spinner/spinner";
import {
  useGetAllResourcePaginationMutation,
  useDeleteResourceMutation,
  useEnableDisableResourceMutation
} from "../../../app/services/resourceHubServices";
import { formatDescription } from "../../../app/utils/utils";
import { selectChapterId, selectCurrentScope, selectSigId } from "../../../app/auth/authSlice";
import { useSelector } from "react-redux";



export default function ListResource() {
  const [resources, setResources] = useState([]);
  const navigate = useNavigate();
  const [getAllResources, { isLoading }] = useGetAllResourcePaginationMutation();
  const [deleteResource] = useDeleteResourceMutation();
  const [enableDisableResource] = useEnableDisableResourceMutation();
  const currentLocation = useLocation();
  var currentPath = currentLocation.pathname.split('/');
  const chapterId = useSelector(selectChapterId);
  const sigId = useSelector(selectSigId);
  const scope = useSelector(selectCurrentScope);

  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");
  const [open1, setOpen1] = useState(false);


  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedResourceId, setSelectedResourceId] = useState(null);

  const pageCount = Math.ceil(totalItems / itemsPerPage) || 1;

  const fetchResources = React.useCallback(async () => {
    try {
      const data = await getAllResources(chapterId ? { page: page + 1, itemsPerPage, chapterId: chapterId } : sigId ? { page: page + 1, itemsPerPage, sigId: sigId } : { page: page + 1, itemsPerPage }).unwrap();
      if (data.status) {
        setResources(data.data.resourceDetails || []);
        setTotalItems(data.data.totalCount || 0);
      } else {
        toast.error(data.err?.message || "Failed to fetch resources");
      }
    } catch (error) {
      toast.error("Error fetching resources");
    }
  }, [page, itemsPerPage, getAllResources, chapterId, sigId]);

  useEffect(() => {
    fetchResources();
  }, [fetchResources]);

  const handleOpenDeleteModal = (id) => {
    setSelectedResourceId(id);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedResourceId(null);
    setDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    if (!selectedResourceId) return;
    try {
      const data = await deleteResource(selectedResourceId).unwrap();
      if (data.status) {
        toast.success("Resource deleted successfully");
        fetchResources();
      } else {
        toast.error(data.err?.message || "Failed to delete");
      }
    } catch (error) {
      toast.error("Error deleting resource");
    } finally {
      handleCloseDeleteModal();
    }
  };

  const handleEnableDisable = async (id) => {
    try {
      const res = await enableDisableResource(id).unwrap();
      if (res.status) {
        toast.success(res.message || "Status updated successfully");
        fetchResources();
      } else {
        toast.error(res.err?.message || res.message || "Failed to update status");
        fetchResources();
      }
    } catch (error) {
      toast.error("Error updating resource status");
    }
  };

  const handlePageClick = ({ selected }) => {
    setPage(selected);
  };

  const handlePageChange = () => {
    const pageNumber = parseInt(searchTerm, 10);
    if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > pageCount) {
      setError(`Please enter a valid page number between 1 and ${pageCount}`);
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };
  const handleOpen1 = (id) => {
    setOpen1(true);
    setSelectedResourceId(id);
  };

  return (
    <Box>
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Resource Hub</h2>
        </div>
      </div>
      <div className='p-md-5 p-3 overallPadding'>
        <div className="text-end w-100">
          <Button variant="contained" className="menus-color poppins-regular" style={{ color: "white", marginBottom: "15px" }} onClick={() => navigate("/" + currentPath[1] + "/add-resource")}>
            Add Resource
          </Button>
        </div>
        <Box>
          <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
              <TableHead>
                <TableRow className='menus-color'>
                  <TableCell sx={{ textAlign: "center", color: "#ffff" }}>Name</TableCell>
                  <TableCell sx={{ textAlign: "center", color: "#ffff", width: '30%' }}>Description</TableCell>
                  <TableCell sx={{ textAlign: "center", color: "#ffff" }}>Category</TableCell>
                  <TableCell sx={{ textAlign: "center", color: "#ffff" }}>Created By</TableCell>
                  <TableCell sx={{ textAlign: "center", color: "#ffff" }}>Status</TableCell>
                  <TableCell sx={{ textAlign: "center", color: "#ffff", minWidth: '150px' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center"><Spinner /></TableCell>
                  </TableRow>
                ) : resources?.length > 0 ? (
                  resources.map((row, index) => (
                    <TableRow
                      hover
                      key={row._id}
                      sx={{
                        cursor: "pointer",
                        backgroundColor: index % 2 === 0 ? "#f0f0f0" : "white",
                      }}
                    >
                      <TableCell align="center">{row.name}</TableCell>
                      <TableCell align="center" sx={{ maxWidth: '350px', wordBreak: 'break-word' }}>
                        <div
                          style={{
                            fontSize: "14px",
                            lineHeight: "1.5",
                            maxHeight: "120px",
                            overflow: "hidden",
                            textAlign: "left"
                          }}
                          dangerouslySetInnerHTML={{ __html: formatDescription(row.description) }}
                        />
                      </TableCell>
                      <TableCell align="center">{row.resourceCategoryId?.name || "N/A"}</TableCell>
                      <TableCell align="center">{row.chapterId ? row.chapterId.title : row.SIGId ? row.SIGId.groupName : "ELTAI"}</TableCell>
                      <TableCell align="center">
                        <div
                          className={`px-2 fw-bold p-1 d-flex align-items-center ${row?.isApproved === 2
                            ? "text-danger"
                            : row?.isApproved === 0
                              ? "text-warning"
                              : "text-success"
                            }`}
                        >
                          {row?.isApproved === 2
                            ? <>Rejected{<i onClick={() => handleOpen1(row)} title="View Reject Reason" className="fa fa-solid fa-eye text-danger cursor-pointer ms-1"></i>}</>
                            : row?.isApproved === 0
                              ? "Pending"
                              : "Approved"}
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="View">
                          <IconButton color="info" onClick={() => navigate(`/${currentPath[1]}/view-resource/${row._id}`)}>
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                        {(scope === "PORTAL_ADMIN" || scope === 'PORTAL_SUPER_ADMIN') ?
                          <Tooltip title="Edit">
                            <IconButton color="primary" onClick={() => navigate(`/${currentPath[1]}/edit-resource/${row._id}`)}>
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          : row.isApproved !== 1 &&
                          <Tooltip title="Edit">
                            <IconButton color="primary" onClick={() => navigate(`/${currentPath[1]}/edit-resource/${row._id}`)}>
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        }
                        {row?.isDeleted === 0 ? (
                          <Tooltip title="Enable">
                            <IconButton aria-label="enable" onClick={() => handleEnableDisable(row._id)}>
                              <LockOpenIcon style={{ color: "green" }} />
                            </IconButton>
                          </Tooltip>
                        ) : row?.isDeleted === 2 ? (
                          <Tooltip title="Disable">
                            <IconButton aria-label="disable" onClick={() => handleEnableDisable(row._id)}>
                              <LockIcon style={{ color: "red" }} />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                        <Tooltip title="Delete">
                          <IconButton color="error" onClick={() => handleOpenDeleteModal(row._id)}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">No Resources Found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <br />
        <br />
        {(resources?.length > 0) && (
          <div className="d-flex justify-content-between flex-lg-row flex-column gx-3 gx-lg-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
            <div className="mb-2 mb-md-0">
              <div className="d-flex gap-2">
                <input
                  type="number"
                  min={1}
                  placeholder="Page no."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                <div className="goPage cursor-pointer" onClick={handlePageChange}>
                  <h5 className="p-2 m-0">Go</h5>
                </div>
              </div>
              {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
            </div>
            <div className="my-3 my-lg-0">
              <ReactPaginate
                pageCount={pageCount}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                forcePage={page}
                previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                nextLabel={pageCount > 1 && page + 1 !== pageCount ? "Next" : null}
                disabledClassName={"disablebtn"}
              />
            </div>
            <div className="mb-2 mb-md-0">
              <FormControl variant="outlined">
                <Select
                  className="itemsperpage"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value, 10));
                    setError('');
                    setSearchTerm('');
                    setPage(0);
                  }}
                  MenuProps={{
                    MenuListProps: { sx: { display: 'flex', flexDirection: 'column' } },
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        )}
      </div>

      <Modal
        open={deleteModalOpen}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-confirmation-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            outline: "none",
          }}
          className="d-flex flex-column gap-3"
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
              Confirmation
            </Typography>
            <IconButton onClick={handleCloseDeleteModal} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </div>
          <Divider sx={{ width: "100%" }} />
          <Typography
            id="delete-confirmation-modal-title"
            style={{ color: "#611f1e" }}
            variant="h6"
            component="h2"
            className="content-font"
          >
            Are you sure you want to delete this resource?
          </Typography>
          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            <Button
              variant="outlined"
              className="content-font"
              style={{
                color: "#dc3545",
                border: "1px solid #dc3545",
                padding: "5px 15px",
                borderRadius: "0px",
              }}
              onClick={handleCloseDeleteModal}
            >
              No
            </Button>
            <Button
              className="content-font"
              variant="contained"
              style={{
                backgroundColor: "#2e7d32",
                color: "white",
                padding: "5px 15px",
                borderRadius: "0px",
              }}
              onClick={confirmDelete}
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal
        open={open1}
        onClose={() => { setOpen1(false); setSelectedResourceId('') }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            backgroundColor: 'white',
            boxShadow: 24,
            padding: "20px",
            outline: 'none',
          }}
        >
          {/* <Typography
                  id="modal-modal-title"
                  style={{ color: "#611f1e" }}
                  variant="h6"
                  component="h2"
                >
                  Reject Reason
                </Typography> */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
              Reject Reason
            </Typography>
            <IconButton onClick={() => { setOpen1(false); setSelectedResourceId('') }} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </div>
          <Box display="flex" justifyContent="center" width="100%">
            <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
          </Box>
          <div>
            {selectedResourceId && selectedResourceId.rejectReason}
          </div>
          <div>
          </div>
        </Box>
      </Modal>
    </Box>
  );
}
